import React, {memo, useEffect} from 'react';

import {useSelector} from 'react-redux';
import {MuiColorInput} from 'mui-color-input'

import mapStateToProps from './mapStateToProps';

import {
    Autocomplete,
    Checkbox,
    FormControlLabel,
    IconButton,
    InputAdornment,
    MenuItem,
    Select,
    TextField,
    Typography
} from '@mui/material'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import DatePicker from '../../DatePicker';
import SaveStatus from '../../SaveStatus';
import {iconArr} from '../../../Components/GeoIconArray';
import useStyles from "../useStyles";
import {TRACKER_TYPES} from "../../../shared/constants/trackerTypes";

const timezone = [
    {label: '-12:00', id: -43200},
    {label: '-11:00', id: -39600},
    {label: '-10:00', id: -36000},
    {label: '-9:30', id: -34200},
    {label: '-9:00', id: -32400},
    {label: '-8:00', id: -28800},
    {label: '-7:00', id: -25200},
    {label: '-6:00', id: -21600},
    {label: '-5:00', id: -18000},
    {label: '-4:00', id: -14400},
    {label: '-3:30', id: -12600},
    {label: '-3:00', id: -10800},
    {label: '-2:00', id: -7200},
    {label: '-1:00', id: -3600},
    {label: '+0:00', id: 0},
    {label: '+1:00', id: 3600},
    {label: '+2:00', id: 7200},
    {label: '+3:00', id: 10800},
    {label: '+3:30', id: 12600},
    {label: '+4:00', id: 14400},
    {label: '+4:30', id: 16200},
    {label: '+5:00', id: 18000},
    {label: '+5:30', id: 19800},
    {label: '+5:45', id: 20700},
    {label: '+6:00', id: 21600},
    {label: '+6:30', id: 23400},
    {label: '+7:00', id: 25200},
    {label: '+8:00', id: 28800},
    {label: '+8:45', id: 31500},
    {label: '+9:00', id: 32400},
    {label: '+9:30', id: 34200},
    {label: '+10:00', id: 36000},
    {label: '+10:30', id: 37800},
    {label: '+11:00', id: 39600},
    {label: '+12:00', id: 43200},
    {label: '+12:45', id: 45900},
    {label: '+13:00', id: 46800},
    {label: '+14:00', id: 50400},
]

/**Фильтр пропускает только целочисленные значения */
const iFilter = (val) => isNaN(parseInt(val)) ? '' : parseInt(val)
/**Фильтр пропускает только числовые с плавающей точкой значения */
const fFilter = (val) => isNaN(parseFloat(val)) ? '' : parseFloat(val)
/**Фильтр мутирует значения даты/времени в правильную форму */
const dFilter = (val) => val.valueOf()

// Функция для получения метки по ключу из словаря
const getOptionLabel = (option) => {
    return TRACKER_TYPES[option] || option
};

function UniField(props) {
    const {
        value,
        type,
        label,
        isId,
        dirName,
        values: enumValue,
        onChange = () => {
        }
    } = props

    const classes = useStyles();

    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const {
        shorts = {},
        loadShortDirectory = () => {
        },
    } = useSelector(mapStateToProps)

    /**загружаем краткий справочник выпадашек */
    useEffect(() => {
        if (dirName && type === 'Dir' && !shorts[dirName]) {
            loadShortDirectory(dirName)
        }
    }, [dirName, type, shorts])

    /**текущий справочник (если есть) */
    const curDir = dirName ? shorts[dirName] : undefined;

    const getDirValueByVal = (val) => {
        return curDir?.find(({id}) => id === val)
    }

    if (isId) {
        return (
            <>
                <Typography variant="caption">
                    {label}
                </Typography>
                <TextField
                    value={value}
                    size='small'
                    fullWidth
                    disabled
                />
            </>
        )
    } else if (type === "String") {
        return (
            <>
                <Typography variant="caption">
                    {label}
                </Typography>
                <TextField
                    value={value}
                    size='small'
                    fullWidth
                    onChange={(e) => onChange(e.target.value)}
                />
            </>
        )
    } else if (type?.toLowerCase() === "color") {
        return (
            <>
                <Typography variant="caption">
                    {label}
                </Typography>
                <MuiColorInput value={value ? value : "#facfac"} onChange={(v) => onChange(v)} format='hex'
                               isAlphaHidden size='small' fullWidth/>
            </>
        )
    } else if (type?.toLowerCase() === "icon") {
        return (
            <>
                <Typography variant="caption">
                    {label}
                </Typography>
                <Select size="small" value={value} onChange={(e) => onChange(e.target.value)} fullWidth>
                    {iconArr.map((Icon, i) => <MenuItem value={i}><Icon/></MenuItem>)}
                </Select>
            </>
        )
    } else if (type === "Int") {
        return (
            <>
                <Typography variant="caption">
                    {label}
                </Typography>
                <TextField
                    value={value}
                    size='small'
                    fullWidth
                    onChange={(e) => onChange(iFilter(e.target.value))}
                />
            </>
        )
    } else if (type === "Float") {
        return (
            <>
                <Typography variant="caption">
                    {label}
                </Typography>
                <TextField
                    value={value}
                    size='small'
                    fullWidth
                    onChange={(e) => onChange(fFilter(e.target.value))}
                />
            </>
        )
    } else if (type === "Password") {
        return (
            <>
                <Typography variant="caption">
                    {label}
                </Typography>
                <TextField
                    type={showPassword ? 'text' : 'password'}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff/> : <Visibility/>}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    value={value}
                    size='small'
                    fullWidth
                    onChange={(e) => onChange(e.target.value)}
                />
            </>
        )
    } else if (type === "Timestamp") {
        return (
            <>
                <Typography variant="caption">
                    {label}
                </Typography>
                <div>

                    <DatePicker
                        value={value}
                        size='small'
                        fullWidth
                        variant="outlined"
                        onChange={(v) => onChange(dFilter(v))}
                    />
                </div>
            </>
        )
    } else if (type === "Timezone") {
        return (
            <>
                <Typography variant="caption">
                    {label}
                </Typography>

                <Select
                    value={value}
                    size='small'
                    fullWidth
                    variant="outlined"
                    className={classes.inputTypeSelect}
                    onChange={(e) => {
                        onChange(1 * e.target.value)
                    }}
                >
                    {timezone.map(({label, id}) => (
                        <MenuItem
                            className={classes.menuItem}
                            value={id}>
                            {label}
                        </MenuItem>)
                    )}
                </Select>
            </>
        )
    } else if (type === "Enum") {
        return (
            <>
                <Typography variant="caption">
                    {label}
                </Typography>

                <Autocomplete
                    disablePortal
                    options={enumValue}
                    value={value}
                    size='small'
                    fullWidth
                    variant="outlined"
                    onChange={(e, newValue) => onChange(newValue)}
                    getOptionLabel={(option) => getOptionLabel(option)}
                    renderOption={(props, option) => (
                        <li {...props} key={option}>
                            {getOptionLabel(option)}
                        </li>
                    )}
                    renderInput={(params) => <TextField {...params} />}
                />
            </>
        )

    } else if (type === "Dir") {
        return (<>
            <Typography variant="caption">
                {label}
            </Typography>
            {curDir ? (
                <Autocomplete
                    disablePortal
                    options={curDir}
                    value={getDirValueByVal(value)}
                    size='small'
                    fullWidth
                    variant="outlined"
                    getOptionLabel={({label}) => label}
                    onChange={(e, newValue) => onChange(newValue?.id || null)}
                    renderInput={(params) => <TextField {...params} />}
                    isOptionEqualToValue={(option, value) => option === value}
                />
            ) : (
                <SaveStatus title="Загрузка выпадающего списка" dataObj={{loading: true}}/>
            )}
        </>)
    } else if (type === "Boolean") {
        return (
            <FormControlLabel className={classes.checkBoxControl}
                              control={<Checkbox checked={value} onChange={(e) => onChange(e.target.checked)}/>}
                              label={label}/>
        )
    }
}


export default memo(UniField);
